"use client";

import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@oreme/ui";
import { Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import React, { type ReactElement } from "react";

function ThemeSwitcher(): ReactElement {
  const t = useTranslations("global.ThemeSwitcher");
  const { theme, setTheme } = useTheme();

  const handleChange = (value: string): void => {
    setTheme(value);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{t("label")}</DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          <DropdownMenuRadioGroup onValueChange={handleChange} value={theme}>
            <DropdownMenuRadioItem
              className="flex flex-row gap-2"
              value="light"
            >
              <Sun size={16} /> {t("light")}
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem className="flex flex-row gap-2" value="dark">
              <Moon size={16} /> {t("dark")}
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}

export { ThemeSwitcher };
